// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const advertisementApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdvertisement: builder.query({
      query: ({ limit, page, search }) =>
        `/api/v1/admin/advertisement/listing?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}`,
      providesTags: (result, error) => [{ type: "Advertisment" }],
    }),
    createAdvertisement: builder.mutation({
      query: (data) => {
        return {
          url: "/api/v1/admin/advertisement",
          method: "POST",
          body: data,
          // headers: {
          //   "Content-Type": "multipart/form-data",
          // },
        };
      },
      invalidatesTags: ["Advertisment"],
    }),

    getAdvertisementById: builder.query({
      query: (id) => `/api/v1/admin/advertisement/${id}`,
      providesTags: (result, error, id) => [{ type: "Advertisment", id }],
    }),

    updateAdvertisement: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `/api/v1/admin/advertisement/${id}`,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["Advertisment"],
    }),

    deleteAdvertisement: builder.mutation({
      query: (id) => ({
        url: `/api/v1/admin/advertisement/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Advertisment"],
    }),
  }),
});

export const {
  useGetAdvertisementQuery,
  useCreateAdvertisementMutation,
  useUpdateAdvertisementMutation,
  useGetAdvertisementByIdQuery,
  useDeleteAdvertisementMutation,
} = advertisementApiSlice;
